// extracted by mini-css-extract-plugin
export var contactBlock = "ContactForm-module--contact-block--1kVv8";
export var contactBlockNoPaddingTop = "ContactForm-module--contact-block-no-padding-top--W8v8r";